import { Badge, Tooltip } from '@apollo/orbit';
import React from 'react';

import { ContactSupportLink } from 'src/components/ContactSupportCTAs';

/**
 * VersionBadge Component
 *
 * This sub-component renders a badge displaying a specified version of things.
 *
 * @param {Object} props - Component properties.
 * @param {string} version - a version of things (ex: router or federation version).
 *
 * @returns {JSX.Element} Rendered badge.
 */
export const VersionBadge = ({ version }: { version: string }) => (
  <Tooltip
    placement="top"
    label={
      <p>
        This may indicate an issue with your Router or Federation version.
        Please
        <ContactSupportLink>contact us</ContactSupportLink>
        for assistance.
      </p>
    }
  >
    <Badge variant="info">{version}</Badge>
  </Tooltip>
);
